import "./landing.css";
import { Icons } from "../Journal/SharedComponents";

import dataDrivenSS from "./Assets/DataDrivenSS.png";
import gratitudeSS from "./Assets/GratitudeSS.png";
import highlightsSS from "./Assets/HighlightsSS.png";
import reacpSS from "./Assets/RecapSS.png";



export function LandingPage() {

    const sendAdEvent = () => {

        let w = window as any;
        
        w.gtag('config', 'AW-16702513277');
        w.gtag('event', 'conversion', { 'send_to': 'AW-16702513277/Te2zCPan5dIZEP3AsJw-' });
    }

    const CTASection = ({ className, img }: { className?: string, img?: string }) => {

        let imgSrc = img ?? "https://www.growthlenses.com/wp-content/uploads/2024/09/HomeScreenshot.png";
        return (
            <div className={"gl-above-the-fold" + (className ? ` ${className}` : '')}>
                <div >
                    <div className="gl-landing-logo-wrapper">
                        <img
                            src="https://www.growthlenses.com/wp-content/uploads/2024/09/gl-logo.png"
                            alt="Growth Lenses' Logo"
                            className="gl-landing-logo"
                        />
                    </div>
                    <h1
                        className="gl-landing-title-typography text-center m-0"
                    >Start Your Journey to</h1>
                    <h1
                        className="gl-landing-title-typography text-center m-0"
                    >Continuous Growth</h1>
                </div>
                <div
                    className="w-full"
                >
                    <div>
                        <img
                            src={imgSrc}
                            className="gl-landing-featured-screenshot"
                        />
                    </div>
                </div>
                <div className="gl-landing-cta">
                    <a
                        className="gl-landing-cta-button"
                        href='https://play.google.com/store/apps/details?id=com.growthlenses.journal'
                        onClick={sendAdEvent}
                    >
                        <img
                            src="https://www.growthlenses.com/wp-content/uploads/2024/09/googlePlayStore.png"
                        />
                    </a>
                    <a
                        className="gl-landing-cta-button"
                        href='https://apps.apple.com/us/app/growth-lenses/id6654929549'
                        onClick={sendAdEvent}
                    >
                        <img
                            src="https://www.growthlenses.com/wp-content/uploads/2024/09/appleAppStore.png"
                        />
                    </a>
                </div>
            </div>
        );
    }

    const Section = ({ title, description, image }: { title: string, description?: string, image: string }) => {

        return (<div className="gl-landing-section flex flex-column align-items-center">
            <div className="flex flex-row justify-content-center align-items-center">
                <Icons.TitleIcon />
                <h2 className="m-0 gl-landing-section-typography color-copy-core">{title}</h2>
            </div>
            <img className="gl-landing-screenshot" src={image} />
            {
                description &&
                <p className="gl-popup-body-typography gl-landing-description">
                    {description}
                </p>}
        </div>);
    }

    return (
        <div className="gl-journal-landing h-full">

            <CTASection />
            <Section
                title="Take Your Life to the Next Level With Data-Driven Insights"
                image={dataDrivenSS}
            />
            <Section
                title="Reflect on Your Highlights to Build Momentum"
                image={highlightsSS}
            />
            <Section
                title="Ground Yourself in Gratitude & Purpose to Start Strong"
                image={gratitudeSS}
            />
            <Section
                title="Track Your Progress and See How Far You’ve Come"
                image={reacpSS}
            />

            <div className="gl-landing-footer">
                <div className="gl-landing-footer-quote flex flex-column align-items-center color-background-copy-core color-white">
                    <p className="gl-popup-body-typography color-white text-left mt-0">Whether you're aiming to <strong>boost productivity</strong>, or <strong>enhance mindfulness</strong>, or <strong>savor magic moments</strong>...</p>
                    <p className="gl-popup-body-typography color-white text-left mb-0">Growth Lenses helps you find the perfect balance of reflection and goal setting to succeed.</p>
                </div>
            </div>

            <CTASection className="h-screen" />
        </div>
    )
}